import React from 'react';
import styled from 'styled-components';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { FaPaw, FaHeart, FaCamera, FaShareAlt } from 'react-icons/fa';
import { Typed } from 'react-typed';
import HeroComponent from '../components/homepage/Hero';

const Section = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4f4 0%, #e4f4f4 100%);
  color: #333;
`;



const FeaturesSection = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 3rem 2rem;
  gap: 2rem;
  background: #f0f4f4;
`;

const FeatureCard = styled.div`
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 15px;
  text-align: center;
  width: 250px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-10px);
  }

  svg {
    font-size: 2rem;
    color: #66b2b2;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    color: #7a7a7a;
  }
`;

const HomePage = () => {
  return (
    <Section>
      <Navbar />

      <HeroComponent />

      {/* <FeaturesSection>
        <FeatureCard>
          <FaPaw />
          <h3>Profiles</h3>
          <p>Create beautiful profiles to showcase your pets.</p>
        </FeatureCard>
        <FeatureCard>
          <FaHeart />
          <h3>Stories</h3>
          <p>Share heartfelt stories about your pets' milestones.</p>
        </FeatureCard>
        <FeatureCard>
          <FaCamera />
          <h3>Photos & Videos</h3>
          <p>Upload memories to cherish forever.</p>
        </FeatureCard>
        <FeatureCard>
          <FaShareAlt />
          <h3>Community</h3>
          <p>Connect with fellow pet lovers around the world.</p>
        </FeatureCard>
      </FeaturesSection> */}

      <Footer />
    </Section>
  );
};

export default HomePage;
